module.exports = __webpack_public_path__ + "static/img/20200629075448_50992.81e5dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20200629075448_50992.png
// module id = k3Zo
// module chunks = 73